import React, { useContext } from 'react'
import { Route } from 'react-router-dom'

import Typography from '@material-ui/core/Typography'

import _userContext from '../../contexts/userContext'

import styles from './PrivateRoute.module.css'

export default function PrivateRoute({ roles, ...props }) {
    const userContext = useContext(_userContext)
    const userRole = userContext.user.role

    return roles.includes(userRole) ? (
        <Route {...props} />
    ) : (
        <Typography variant="h5" className={styles.page__title}>
            Нет прав на просмотр страницы {props.path} ⛔
        </Typography>
    )
}
